import React, { Component } from 'react';
import { Grid, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../functions/server'
import $ from "jquery";
import Loading from '../loadings';

class Edit extends Component {

  state = {
    name: this.props.name,
    min_stock: this.props.min_stock,
    rackno: this.props.rackno,
    id: this.props.id,
    data: this.props.data,
    partno: this.props.partno,
    load: false,
    message: ''
  };


  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  cancel() {
    this.props.handleClose();
  }

  update() {

    let context = this;
    context.setState({
      load: true,
      message: 'Updating Branch Details'
    });
    let name = this.state.name;
    let min_stock = this.state.min_stock;
    let rackno = this.state.rackno;
    let id = this.state.id;
    let oldData = this.state.data;
    let partno = this.state.partno;
    if (name == '' || name == null || name == undefined) {
      context.setState({
        error: 'Enter Branch name field!!!',
      });
      return;
    }

    if (min_stock == '' || min_stock == null || min_stock == undefined) {
      context.setState({
        error: 'Enter min_stock field!!!',
      });
      return;
    }

    if (rackno == '' || rackno == null || rackno == undefined) {
      context.setState({
        error: 'Enter Branch taluk field!!!',
      });
      return;
    }
    let data1 = { 'name': name, 'min_stock': min_stock, 'rackno': rackno, 'id': id, 'partno': partno };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'branchdetails/updatebranchdata.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        if (data == 1) {
          for (var i = 0; i < oldData.length; i++) {
            if (id == oldData[i].id) {
              oldData[i].name = name;
              oldData[i].min_stock = min_stock;
              oldData[i].rackno = rackno;
            }
          }
          context.props.updateData(oldData);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    let { load, message } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Minimum<br/>
            <Input focus value={this.state.min_stock}
                onChange={this.onChange('min_stock')}
                placeholder='Minimum stock' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Rack No<br/>
            <Input focus value={this.state.rackno}
                onChange={this.onChange('rackno')}
                placeholder='Rack No' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.update.bind(this)}>Save</Button>
          </Grid.Column>
        </Grid>
        <Loading load={load} message={message} />
      </div>
    );
  }
}

export default Edit;
